import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as l, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconSunDim",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, r, h, _, a) {
  return d(), n("svg", {
    "aria-label": r.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--sun-dim"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Sun Dim",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.232 4.232a2.5 2.5 0 1 1 3.536 3.536 2.5 2.5 0 0 1-3.536-3.536ZM6 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM5.5 2a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm4 4a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H10a.5.5 0 0 1-.5-.5Zm-4 4a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm-4-4a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5Zm6.829-2.828a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Zm0 5.656a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Zm-5.658 0a.5.5 0 0 1 .5-.5h.006a.5.5 0 0 1 0 1H3.17a.5.5 0 0 1-.5-.5Zm0-5.656a.5.5 0 0 1 .5-.5h.006a.5.5 0 0 1 0 1H3.17a.5.5 0 0 1-.5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, c);
}
const H = /* @__PURE__ */ s(m, [["render", u]]);
export {
  H as default
};
//# sourceMappingURL=sun-dim.js.map
